import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange"],
  _excluded2 = ["children"],
  _excluded3 = ["prefixCls", "selectPrefixCls", "className", "size", "selectComponentClass"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import RcPagination from 'rc-pagination';
import LeftOutlined from '@ant-design/icons/LeftOutlined';
import RightOutlined from '@ant-design/icons/RightOutlined';
import DoubleLeftOutlined from '@ant-design/icons/DoubleLeftOutlined';
import DoubleRightOutlined from '@ant-design/icons/DoubleRightOutlined';
import { Select } from '../../Select';
import { ConfigContext } from '../../../config/context/config';
function AdpCombineSelect(props) {
  var onChange = props.onChange,
    extra = _objectWithoutProperties(props, _excluded);
  return React.createElement(Select, _objectSpread(_objectSpread({}, extra), {}, {
    onValueChange: onChange
  }));
}
var AdpCombineSelectOption = function AdpCombineSelectOption(_ref) {
  var children = _ref.children,
    extra = _objectWithoutProperties(_ref, _excluded2);
  return React.createElement(Select.Option, _objectSpread(_objectSpread({}, extra), {}, {
    label: String(children),
    children: children
  }));
};
Object.assign(AdpCombineSelect, {
  Option: AdpCombineSelectOption
});
export var Pagination = function Pagination(_ref2) {
  var customizePrefixCls = _ref2.prefixCls,
    customizeSelectPrefixCls = _ref2.selectPrefixCls,
    className = _ref2.className,
    size = _ref2.size,
    selectComponentClass = _ref2.selectComponentClass,
    restProps = _objectWithoutProperties(_ref2, _excluded3);
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls('pagination', customizePrefixCls);
  var getIconsProps = function getIconsProps() {
    var ellipsis = React.createElement("span", {
      className: "".concat(prefixCls, "-item-ellipsis")
    }, "\u2022\u2022\u2022");
    var prevIcon = React.createElement("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1
    }, React.createElement(LeftOutlined, null));
    var nextIcon = React.createElement("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1
    }, React.createElement(RightOutlined, null));
    var jumpPrevIcon = React.createElement("a", {
      className: "".concat(prefixCls, "-item-link")
    }, React.createElement("div", {
      className: "".concat(prefixCls, "-item-container")
    }, React.createElement(DoubleLeftOutlined, {
      className: "".concat(prefixCls, "-item-link-icon")
    }), ellipsis));
    var jumpNextIcon = React.createElement("a", {
      className: "".concat(prefixCls, "-item-link")
    }, React.createElement("div", {
      className: "".concat(prefixCls, "-item-container")
    }, React.createElement(DoubleRightOutlined, {
      className: "".concat(prefixCls, "-item-link-icon")
    }), ellipsis));
    return {
      prevIcon: prevIcon,
      nextIcon: nextIcon,
      jumpPrevIcon: jumpPrevIcon,
      jumpNextIcon: jumpNextIcon
    };
  };
  var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
  return React.createElement(RcPagination, _objectSpread(_objectSpread(_objectSpread({}, getIconsProps()), restProps), {}, {
    prefixCls: prefixCls,
    selectPrefixCls: selectPrefixCls,
    className: className,
    selectComponentClass: selectComponentClass || AdpCombineSelect
  }));
};